import axios from 'axios';

const BASE = '/api/festival-sale';

const getProposal = async (targetId) => {
    const response = await axios.get(`${BASE}/proposal/${targetId}`);
    return response.data;
};

const approveAndSave = async (targetId, data) => {
    const response = await axios.post(`${BASE}/proposal/${targetId}/approve`, data);
    return response.data;
};

const uploadBanner = async (targetId, imageData) => {
    const response = await axios.post(`${BASE}/proposal/${targetId}/upload-banner`, { imageData });
    return response.data;
};

const rejectProposal = async (targetId) => {
    const response = await axios.post(`${BASE}/proposal/${targetId}/reject`, {});
    return response.data;
};

export default {
    getProposal,
    approveAndSave,
    uploadBanner,
    rejectProposal
};
